import { parseFullName } from "parse-full-name";

import type { AuthStaff } from "@elation/api-client/src/stitch-web/models/authStaff";

import { compactStrings } from "@src/shared/utils/strings";

import type { StaffProfileFormValues } from "./staff.schemas";

type MaybeStaff = AuthStaff | null | undefined;

export const StaffEntity = {
  initials(staff: MaybeStaff): string | null {
    if (!staff) return null;
    const parsed = parseFullName(
      compactStrings([staff.firstName, staff.lastName]).join(" "),
    );

    return compactStrings([parsed.first, parsed.last])
      .map((part) => part.at(0))
      .join("")
      .toUpperCase();
  },

  fullName(staff: MaybeStaff): string | null {
    if (!staff) return null;
    return compactStrings([staff.firstName, staff.lastName]).join(" ");
  },

  displayName(staff: MaybeStaff): string | null {
    return StaffEntity.fullName(staff);
  },

  isSelectable(staff: MaybeStaff): boolean {
    if (!staff) return false;
    return staff.isActive;
  },

  toProfileFormValues(staff: MaybeStaff): StaffProfileFormValues {
    return {
      firstName: staff?.firstName ?? "",
      lastName: staff?.lastName ?? "",
    };
  },
} as const;
